import { useReactTable, getCoreRowModel, getFilteredRowModel, getFacetedUniqueValues, getFacetedMinMaxValues, getSortedRowModel } from '@tanstack/react-table';
import { useState } from 'react';

export function useTableConfig(data, initialSorting = []) {
    const columns = [
        {
            accessorKey: 'year',
            header: 'år',
            pluralName: 'år',
            filterFn: 'equals'
        },
        {
            accessorKey: 'municipality',
            header: 'kommun',
            pluralName: 'kommuner',
            filterFn: 'equals'
        },
        {
            accessorKey: 'school',
            header: 'skola',
            pluralName: 'skolor',
            filterFn: 'equals'
        },
        {
            accessorKey: 'program',
            header: 'program',
            pluralName: 'program',
            filterFn: 'equals'
        },
        {
            accessorKey: 'remark',
            header: 'anmärkning',
            pluralName: 'anmärkningar',
        },
        {
            accessorKey: 'preliminary_lowest_merit',
            header: 'preliminär antagning - lägsta',
            pluralName: 'preliminär antagning - lägsta',
            filterFn: 'between'
        },
        {
            accessorKey: 'preliminary_average_merit',
            header: 'preliminär antagning - medel',
            pluralName: 'preliminär antagning - medel',
            filterFn: 'between'
        },
        {
            accessorKey: 'final_lowest_merit',
            header: 'slutlig antagning - lägsta',
            pluralName: 'slutlig antagning - lägsta',
            filterFn: 'between'
        },
        {
            accessorKey: 'final_average_merit',
            header: 'slutlig antagning - medel',
            pluralName: 'slutlig antagning - medel',
            filterFn: 'between'
        }
    ];

    const [columnFilters, setColumnFilters] = useState([]);
    const [columnVisibility, setColumnVisibility] = useState({
        year: false
    });
    const [sorting, setSorting] = useState(initialSorting);

    const table = useReactTable({
        data,
        columns,
        state: {
            columnFilters,
            columnVisibility,
            sorting,
        },
        onColumnFiltersChange: setColumnFilters,
        onColumnVisibilityChange: setColumnVisibility,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getFacetedUniqueValues: getFacetedUniqueValues(),
        getFacetedMinMaxValues: getFacetedMinMaxValues(),
        getSortedRowModel: getSortedRowModel(),
    });

    return table;
}